import api from "../../../utilidades/interceptor";
const urlApi = process.env.REACT_APP_API_KEY;

export const getCitas = async (data) => {
    try {

        const result = await api.post(`${urlApi}/innovationDevelopment/getAppointments`, data);
        return result.data;

    } catch (error) {
        console.log("error", error);
    }
}
export const getOperadoresDisponibles = async (params) => {
    try {
        const result = await api.get(`${urlApi}/talentoHumano/getOperador`, params);
        return result.data;
    } catch (error) {
        console.log("error", error);
    }
}
